// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w4N6","label":"styles_label__21or-"};